module.exports = __webpack_public_path__ + "media/images/fax-52901ae2420a9e9837d9eaca0e7c0ab4.pdf";